export default __webpack_public_path__ + "static/media/img-visionCircle.50693f8a.svg";